export default __webpack_public_path__ + "static/cornerstone5-ef5654a92ce0f5b58b9d38420825c10e.png";